import { render, staticRenderFns } from "./browser.vue?vue&type=template&id=8272cb10&"
import script from "./browser.vue?vue&type=script&lang=js&"
export * from "./browser.vue?vue&type=script&lang=js&"
import style0 from "./browser.vue?vue&type=style&index=0&id=8272cb10&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports